import { Switch as AntSwitch } from 'antd';
import { SwitchProps as AntSwitchProps } from 'antd/es/switch';
import React from 'react';
import styled from 'styled-components';
import { theme } from '../../theme/semanticTokens';

export interface SwitchProps extends Omit<AntSwitchProps, 'size'> {
  size?: 'default' | 'small';
  className?: string;
}

const StyledSwitch = styled(AntSwitch)`
  &.ant-switch {
    background-color: ${theme.dime.colors.fill.secondary};
    /* 999px guarantees a pill on rectangles — 100% creates an ellipse when width > height */
    border-radius: 999px;

    .ant-switch-handle::before {
      background-color: ${theme.dime.colors.fill.primary};
      border-radius: 50%;
    }

    &.ant-switch-checked {
      background-color: ${theme.dime.colors.action.primary};

      &:hover:not(.ant-switch-disabled) {
        background-color: ${theme.dime.colors.action.primaryHover};
      }
    }

    &.ant-switch-disabled {
      background-color: ${theme.dime.colors.fill.disabled};
      opacity: 1;

      .ant-switch-handle::before {
        background-color: ${theme.dime.colors.fill.primary};
      }
    }

    &:hover:not(.ant-switch-disabled):not(.ant-switch-checked) {
      background-color: ${theme.dime.colors.fill.tertiary};
    }
  }
`;

export const Switch: React.FC<SwitchProps> = ({
  size = 'default',
  className,
  ...rest
}) => {
  return <StyledSwitch size={size} className={className} {...rest} />;
};
